
import {getCompetitionHomeInfo} from "@/api/competition";
import {formatDateAndTime, formatTime} from "@/utils/dateFun";

const state = {
  banner:[],// Banner 轮播图。
notice: [],//通知公告。最近 8 条
  intro: "",//大赛简介。
}
const getters = {
  getBanner: (state) => state.banner,
  getIntro: (state) => state.intro,
}
const mutations = {

}
function getCountArr(arr,count){
  if(Array.isArray(arr)){
    const data =  arr.splice(0, count);
    data.forEach(item=>{
     if(item.CreatedAt){
       item.date = formatDateAndTime(item.CreatedAt)[0]
     }
     if(item.StartTime){ // 主要处理预约的时间
       item.StartTimeDeal = formatTime(item.StartTime)
     }
    })
    return data
  }else{
    return []
  }
}
const actions = {
  async getCompetitionHomeInfoAction(context){
    const res = await getCompetitionHomeInfo()
    if(res.err_code===0){
      if(res.data){
      context.state.banner =  getCountArr(res.data.banner,8)
      context.state.notice = getCountArr(res.data.notice,8)
      context.state.intro =  res.data.intro || ""
      }
    }
    return Promise.resolve(res)
  }

}
const modules = {}
export default {
  namespaced: true,
  state() {
    return state
  },
  getters,
  mutations,
  actions,
  modules
}

